import { TreeNode } from "@shared/ui-native/Tree";


const getProcessingText = (node: TreeNode) => {

    const div = document.createElement("div");
    div.style.display = "flex";
    div.style.flexDirection = "row";
    div.style.alignItems = "space-around";

    const nameDiv = document.createElement("div");
    nameDiv.innerHTML = `${node.text}`;

    const processingDiv = document.createElement("div");
    processingDiv.innerHTML = "<b> (" + __("js_files.processing") + ")</b>";
    processingDiv.style.color = "var(--ik-color-neutral-light-500)";

    div.appendChild(nameDiv);
    div.appendChild(processingDiv);

    return div.innerHTML;
}


const setNodeToProcessing = (node: TreeNode) => {
    node.setText(getProcessingText(node));
    node.setEnabled(false);
    node.setLoading(true);
}

const resetNode = (node: TreeNode, originalNodeText: string) => {
    node.setText(originalNodeText);
    node.setError(null);
    node.setLoading(false);
    node.setEnabled(true);
}

const disableNode = (node: TreeNode) => {
    node.setLoading(false);
    node.setChecked(0);
    node.setError(__('general.failed_to_load_data'));
    node.setEnabled(false);
}


export const TreeNodeUtils = {
    setNodeToProcessing,
    resetNode,
    disableNode
}
